import { BreadCrumb, Table } from 'components'
import React, { useEffect, useMemo, useState } from 'react'
import { bindActionCreators } from 'redux';
import { fetchMleSectionData } from 'containers/Checker/checker.utils';
import {useHistory, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchMLEFormInProcessRequest, saveAndContinueSuccessV1 } from './redux/merchantLegalEntity.actions';
import { fetchMleDataDraft } from './merchantLegalEntity.utils';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import MLEDraftData from './redux/model/mleDraftData';
import { BUSINESSDETAILS } from './constants';
import { hideLoader, showLoader } from 'redux/common/loader/loader.actions';

const MleUserActions = ({ data, history, actions }) => {
    const handleClick = () => {
        let requestData = {
            forms: [{
                ...data.original
            }]
        }
        actions.saveAndContinueSuccessV1(requestData);
        history.push(`/mle-onboarding/create/${BUSINESSDETAILS}`)
    };

    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                id="edit-merchant"
                onClick={() => handleClick()}
            />
        </div>
    );
};

const MleDraftTable = (props) => {
    console.log("MleDraftTable....");
    const {
        actions,
        merchantLegalEntityData,
        loader: { showLoader }
    } = props;

    const history = useHistory();

    const {listingDraftData = [{}], listingError = ''} = merchantLegalEntityData;
    const [tableData, setTableData] = useState([]);
    // const [roleStatus, setRoleStatus] = useState('');
    // const [pageCount, setPageCount] = useState(0);
    // const [isResetPage, setIsResetPage] = useState(false);

    const columnsDraft = useMemo(
        () => [
            { header: 'Application ID', accessor: 'id' },
            { header: 'Entity Name', accessor: 'entityName' },
            { header: 'Email ID', accessor: 'emailId' },
            { header: 'Maker ID', accessor: 'makerId' },
            { header: 'Created At', accessor: 'createdOn' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const fetchDataDraft = async () => {
        actions.showLoader()
        try {

            const mledraftData = await fetchMleDataDraft();
            if (mledraftData?.statusCode === apiStatusCodes.SUCCESS) {
                const modelData = new MLEDraftData(mledraftData.forms)
                console.log("modelData", modelData)
                console.log("table data", modelData.tableData);
                setTableData(modelData.tableData);
                // add a actions here     
            }
            
            // actions.fetchMLEFormInProcessRequest()
        } catch(e) {

        } 
        actions.hideLoader()
    }

    useEffect(() => {
        fetchDataDraft()
    }, []);

    

    const handleBackClick = () => {
        history.push('/mle-onboarding');
    };

    const handleCreateMerchant = () => {};
    
    return (
        <>
        <div className='checker-wrapper'>
        <Table
            id="mle-draft"
            tableTitle="MLE Drafts"
            filterActionTitle="Create MLE"
            filterActionPermission="create_mle_button"
            isFiltersEnable
            columns={columnsDraft}
            filterData={{}}
            data={tableData}
            error={listingError}
            loading={showLoader}
            // roleStatus={roleStatus}
            // pageCount={pageCount}
            // isResetPage={isResetPage}
            // afterResetPage={() => setIsResetPage(false)}
            fetchData={() => {}}
            // numberOfRecord={
            //     pagination && pagination.totalNumberOfRecords
            // }
            // pageSizeOptions={pageSizeOptions}
            // paginationLabel="Rows per page"
            onClickTableAction={handleCreateMerchant}
            // setRoleStatus={setRoleStatus}
            userActions={data => {
                
                
                return <MleUserActions data={data} actions={actions} history={history} />
            }}
            additionalActions={null}
            tableSubSection={props => (
                <BreadCrumb
                    {...props}
                    withBack
                    wrapperClass="draft-section"
                    onBackClick={handleBackClick}
                    title="MLE Onboarding"
                    breadCrumbs={[]}
                />
            )}
            // pagePerView={3}
            tableActionPopup={null}
        />
        </div>
        </>
    )
}

const mapStateToProps = ({ loader, merchantLegalEntityData }) => ({
    loader,
    merchantLegalEntityData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMLEFormInProcessRequest,
            saveAndContinueSuccessV1,
            showLoader,
            hideLoader
        },
        dispatch
    ),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MleDraftTable)
);
